import { render, staticRenderFns } from "./CRList.vue?vue&type=template&id=15927e10&scoped=true"
import script from "./CRList.vue?vue&type=script&setup=true&lang=ts"
export * from "./CRList.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./CRList.vue?vue&type=style&index=0&id=15927e10&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15927e10",
  null
  
)

export default component.exports